import React from 'react';
import { RedirectTableCell } from '../../components/utilities/Table/RedirectTableCell';
import AmountGeneralRequest from '../../components/utilities/Table/generalColumns/AmountGeneralRequest';
import { RequestId } from '../../components/utilities/Table/generalColumns/RequestId';

const requestsListStatusEmployees = [
    {
        id: 'bolsa_general_desembolso',
        label: 'CRÉDITO PARA EMPLEADOS',
        status: '7,60,90',
        responsable: null,
        columns: [
            RequestId,
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Producto',
                accessor: 'empleado_credito_producto.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                typeId: 'HeaderIdentification',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
                typeId: 'HeaderClient',
            },
            AmountGeneralRequest({
                id: 'monto_aprobado',
                Header: 'Monto Aprobado',
                accessor: 'monto_aprobado',
            }),
            {
                Header: 'Estado',
                accessor: 'estado_credito.label',
            },
            {
                Header: 'Usuario',
                accessor: 'usuario_creacion.name',
            },
        ],
    },
];

export default requestsListStatusEmployees;
